import { Assort } from "../../../models/Assort";
import { Exercise } from "../../../models/Exercise";
import getId from "../../../../utils/getId";
import { Instructor } from "../../../models/Instructor";

export class Hours {
  constructor(data: any) {
    this.time = data.time;
    this.days = data.days;
  }
  time: string;
  days: Days[];
}
export class Days {
  constructor(data: any) {
    this.day = data.day;
    this.exercise = data.exercise;
  }
  day: string;
  exercise: Exercise[];
}

export interface ExerciseFiltersObject {
  exerciseGroups: Assort;
  zones: Assort;
  humans: Instructor;
}

export default function useAdditionalHooks(
  filters: ExerciseFiltersObject,
  setFilters: (filters: ExerciseFiltersObject) => void
) {
  const isSomeFiltersSelected = () => {
    if (getId(filters.exerciseGroups) || getId(filters.humans) || getId(filters.zones)) {
      return true;
    } else {
      return false;
    }
  };

  const handleResetFilters = () => {
    setFilters({} as ExerciseFiltersObject);
  };

  return {
    isSomeFiltersSelected,
    handleResetFilters,
  };
}
